import React from 'react';
import { StarIcon, BadgeCheckIcon } from 'lucide-react';
import type { Testimonial } from '../data/testimonials';
export function TestimonialCard({
  testimonial
}: {
  testimonial: Testimonial;
}) {
  return <div className="flex flex-col rounded-xl border border-gray-200 bg-gray-50 p-7 transition-shadow duration-150 ease-out hover:shadow-md" data-id="element-157" data-mp="2kgq5yk64snvh">
      {testimonial.foto && <img src={testimonial.foto} alt={`Foto de ${testimonial.nombre}`} className="mb-5 h-20 w-20 rounded-full border-[3px] border-mint object-cover" data-id="element-158" data-mp="2u71igv3vs5dz" />}
      <div className="mb-3 flex gap-0.5 text-amber" aria-label="Calificación 5 de 5 estrellas" data-id="element-159" data-mp="3458m6c95sqy1">
        {Array.from({
        length: 5
      }).map((_, i) => <StarIcon key={i} className="h-[18px] w-[18px] fill-amber" aria-hidden="true" data-id="element-160" data-mp="3860vt6ly0xuu" data-mpi={i} />)}
      </div>
      <p className="flex-1 text-base italic leading-relaxed text-gray-800" data-id="element-161" data-mp="19sr2tfrfyayo">“{testimonial.texto}”</p>
      <p className="mt-5 text-sm font-bold text-mint-dark" data-id="element-162" data-mp="1dst7lxsh3ki6">
        {testimonial.nombre} | {testimonial.edad} años | {testimonial.ciudad}
      </p>
      <p className="mt-1 flex items-center gap-1 text-xs text-success" data-id="element-163" data-mp="d1kshi7iku0j">
        <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-164" data-mp="d09szul3q8f8" /> Compra verificada
      </p>
    </div>;
}